export function setFullHeight() {
  document.getElementById('root').style.height = '100%';
  document.getElementsByTagName('body')[0].style.height = '100%';
  document.getElementsByTagName('html')[0].style.height = '100%';
}
